import { Filter } from "@api/models/HttpClientModels";

export default class OrderFilter extends Filter {
    userIds? : string;
    restaurantIds?: string;
    dateCreatedFrom?: string;
    dateCreatedTo?: string;
    isConfirmed?: boolean;
    isComingForOrder?: string;
}